import { useRef, useState } from "react";
import { Upload, X, Image as ImageIcon } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError, API_BASE } from "../../lib/api";
import { Button } from "../ui/button";
import { FieldLabel } from "./controls";

export const LogoField = ({ s, setS }) => {
  const [bust, setBust] = useState(Date.now());
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);
  const logoUrl = s.receipt_logo_path
    ? `${API_BASE}/settings/logo?consortium_id=${encodeURIComponent(s.consortium_id || "")}&t=${bust}`
    : null;

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) return toast.error("El logo debe pesar menos de 2 MB");
    setUploading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/settings/logo", form, { headers: { "Content-Type": "multipart/form-data" } });
      setS((prev) => ({ ...prev, receipt_logo_path: data.path }));
      setBust(Date.now());
      toast.success("Logo subido");
    } catch (err) { toast.error(formatApiError(err)); }
    setUploading(false);
    if (fileRef.current) fileRef.current.value = "";
  };

  const remove = async () => {
    if (!window.confirm("¿Eliminar el logo del recibo?")) return;
    try {
      await api.delete("/settings/logo");
      setS((prev) => ({ ...prev, receipt_logo_path: null }));
      toast.success("Logo eliminado");
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div>
      <FieldLabel title="Logo del recibo" hint="PNG / JPG / WebP / SVG, máx. 2 MB. Se imprime en escala de grises." />
      <div className="flex items-center gap-3 mt-1">
        <div className="w-20 h-20 border-2 border-dashed border-slate-300 rounded-sm bg-slate-50 flex items-center justify-center overflow-hidden shrink-0">
          {logoUrl ? <img src={logoUrl} alt="Logo" className="max-w-full max-h-full object-contain" data-testid="settings-logo-preview" /> : <ImageIcon className="w-6 h-6 text-slate-300" />}
        </div>
        <div className="flex flex-col gap-2">
          <input ref={fileRef} type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" onChange={upload} className="hidden" data-testid="settings-logo-input" />
          <Button variant="outline" onClick={() => fileRef.current?.click()} disabled={uploading} className="rounded-sm border-slate-300 font-semibold h-9" data-testid="settings-logo-upload">
            <Upload className="w-3.5 h-3.5 mr-1.5" />
            {uploading ? "Subiendo…" : logoUrl ? "Cambiar logo" : "Subir logo"}
          </Button>
          {logoUrl && (
            <Button variant="outline" onClick={remove} className="rounded-sm border-red-300 text-red-700 hover:bg-red-50 font-semibold h-9" data-testid="settings-logo-remove">
              <X className="w-3.5 h-3.5 mr-1.5" /> Quitar
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
